export const getWebsiteAddress = (website: string | undefined) => {
  return website?.match(/https:\/\/|http:\/\//g)
    ? website
    : `https://${website}`;
};
